"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageContainer = void 0;
var tslib_1 = require("tslib");
var React = (0, tslib_1.__importStar)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
function PageContainer(props) {
    var width = props.width, children = props.children, _a = props.isFluid, isFluid = _a === void 0 ? false : _a;
    return (React.createElement(StyledDiv, { className: "PageContainer", isFluid: isFluid, width: width }, children));
}
exports.PageContainer = PageContainer;
var StyledDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  ", "\n  margin-left: auto;\n  margin-right: auto;\n"], ["\n  ", "\n  margin-left: auto;\n  margin-right: auto;\n"])), function (_a) {
    var isFluid = _a.isFluid, width = _a.width;
    return isFluid
        ? "\n        width: 100%;\n        max-width: ".concat(width, ";")
        : "\n        width: ".concat(width, ";\n  ");
});
var templateObject_1;
//# sourceMappingURL=index.js.map